function CtxResizeDirective ($window ) {
    return {
        restrict: 'A',
        scope: {
            ctxResize: '&'
        },
        link: function(scope, element){
            let w = angular.element($window);

            let handler = () => {
                scope.ctxResize();
            };

            w.on('resize', null, null, handler);

            scope.$on('$destroy', function(){
                w.off('resize', null, handler);
            })
        }
    };
}

module.exports = CtxResizeDirective;


// WEBPACK FOOTER //
// ./src/shared/utils/ctxResize.directive.js